export default class Observable {
  constructor() {
    this.observers = [];
  }

  subscribe(f) {
    const i = this.observers.findIndex((o) => o === f);
    if (i === -1) {
      this.observers.push(f);
    }
    // console.log('Observable.subscribe:', this.observers);
  }

  unsubscribe(f) {
    const i = this.observers.findIndex((o) => o === f);
    if (i > -1) {
      this.observers.splice(i, 1);
    }
  }

  notify(data) {
    // console.log("Observable.notify: [", data, "]");
    this.observers.map((observer) => observer(data));
  }
}
